import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenantPath } from 'shared/hooks/useTenantPath';

/**
 * navigate() that keeps /{tenantName} in the URL.
 * navigateTenant('/system-register/software') → /datahouse/system-register/software
 */
export function useTenantNavigate() {
  const navigate = useNavigate();
  const { tp, slug } = useTenantPath();

  const navigateTenant = useCallback(
    (to, options) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }
      if (typeof to === 'string') {
        navigate(tp(to), options);
        return;
      }
      if (to && typeof to === 'object' && to.pathname != null) {
        navigate({ ...to, pathname: tp(to.pathname) }, options);
        return;
      }
      navigate(to, options);
    },
    [navigate, tp]
  );

  return { navigateTenant, tp, slug, navigate };
}
